<template>
  <div class="row mx-0">
    <div class="col-1"></div>
    <div class="col-10">
      <div class="p-0 m-0 mt-4 main-title">帳號管理</div>
      <div style="margin-top: 2rem">
        <div class="row">
          <template v-if="mod == false">
            <userBasic />
          </template>
          <template v-else-if="mod == true">
            <userChangePassword />
          </template>
        </div>
      </div>
    </div>
    <div class="col-1"></div>
  </div>
</template>

<script>
import userBasic from "@/components/permissionManagement/userManagement/userBasic.vue";
import userChangePassword from "@/components/permissionManagement/userManagement/userChangePassword.vue";
import { computed, provide, ref } from "vue";
import store from "@/store";
import { Decrypt } from "@/store/modules/aes";
import { getRSAPublicKey, rsaDecrypt } from "@/store/modules/rsa";
export default {
  components: {
    userBasic,
    userChangePassword,
  },
  setup() {
    //getters
    const loginData = computed(() => store.getters["getLogin/get_loginData"]);
    const sideNavPath = computed(
      () => store.getters["sideBarTree/get_sideNavPath"]
    );
    const axiosResult = computed(
      () => store.getters["commonAxios/get_axiosResult"]
    );

    //dispatch
    const methods = {
      axiosAction: async (payload) => {
        await store.dispatch("commonAxios/axiosAction", payload);
      },
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
    };

    const mod = ref(false);

    const updatePassword = () => {
      mod.value = true;
    };
    const checkUpdate = (account, password, newPassword, checkNewPassword) => {
      // mod.value = false;
      console.log(password, newPassword, checkNewPassword);
      if (newPassword !== checkNewPassword) {
        methods.setTimeoutAlert("請確認新密碼，新密碼不一致");
        return;
      }

      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["uID"] = account;
      params["vuePage"] = "permissionmanagement";
      params["methods"] = "GET";
      params["whichFunction"] = "CheckPassword";
      params["RSAPublicKey"] = getRSAPublicKey();
      methods.axiosAction(params).then(() => {
        let result = axiosResult.value;

        if (result["Response"] != "ok") {
          methods.setTimeoutAlert(result["Response"]);
        } else {
          // 確認資料不為空
          if (result["QueryTableData"].length > 0) {
            let key = JSON.parse(rsaDecrypt(result["QueryTableData"][0].key));
            if (result["QueryTableData"][0].uID != account) {
              methods.setTimeoutAlert("請稍後嘗試");
              return;
            }
            if (
              password ===
              Decrypt(result["QueryTableData"][0].pwd, key.key, key.iv)
            ) {
              changePwd(account, newPassword);
            } else {
              methods.setTimeoutAlert("密碼錯誤");
              return;
            }
          } else {
            methods.setTimeoutAlert("請稍後嘗試");
            return;
          }
        }
      });
    };
    const changePwd = (account, newPassword) => {
      let params = {};
      params["webPage"] =
        sideNavPath.value.length != 0
          ? sideNavPath.value[sideNavPath.value.length - 1]
          : null;
      params["user"] = loginData.value.account;
      params["uID"] = account;
      params["name"] = loginData.value.username;
      params["pwd"] = newPassword;
      params["vuePage"] = "permissionmanagement";
      params["methods"] = "PATCH";
      params["whichFunction"] = "ChangePwd";
      methods.axiosAction(params).then(() => {
        let result = axiosResult.value;

        if (result["Response"] == "ok") {
          methods.setTimeoutAlert("修改成功");
          mod.value = false;
        } else {
          methods.setTimeoutAlert("請稍後嘗試");
        }
      });
    };
    const cancelUpdate = () => {
      mod.value = false;
    };

    const commonMethods = {
      updatePassword: updatePassword,
      checkUpdate: checkUpdate,
      cancelUpdate: cancelUpdate,
    };

    provide("mod", mod);
    provide("commonMethods", commonMethods);
    return { mod };
  },
};
</script>

<style></style>
